module.exports = __webpack_public_path__ + "img/product5.556f7635.jpg";